import { Component } from '@angular/core';
import { AuthenticationService } from 'app/shared/authentication/authentication.service';

@Component({
  selector: 'app-content-layout',
  templateUrl: './content-layout.component.html',
  styleUrls: ['./content-layout.component.scss']
})

export class ContentLayoutComponent {

  constructor(public authenticationService: AuthenticationService) {
  }

}
